import { useEffect, useRef } from "react";
import { CAMPAIGN_TYPES, INPUTS_PROPS } from "../../../../enums/Enums";
import Strings from "../../../../resources/Strings";
import Icons from "../../../../resources/icons/Icons";
import classes from "./MessagingContentCard.module.css";
import { Button, Divider } from "@mui/material";
import ContentEditable from "react-contenteditable";
import { downloadAttachmentByCampaignId } from "../../../../utils/MenuUtils";

const CampaignDetailsContentCard = (props) => {
  const campaign = {...props};
  const fileName = campaign.attachmentName ? campaign.attachmentName : Strings.EXISTING_FILE_NAME;
  const contentEditableRef = useRef(null);

  useEffect(() => {
    if (contentEditableRef !== null) {
      // remove editable attribute - for readonly
      contentEditableRef.current.el.current.attributes?.removeNamedItem('contenteditable');
    }

  }, [contentEditableRef]);

  return (
    <div className={classes.contentCardContainer}>
      <Divider />
      <div className={classes.messagingContainer}>
        <div className={classes.messagingItem}>
          <div className={classes.total}>{Strings.INPUT_LABELS.CAMPAIGN_TYPE}</div>
          <div className={classes.total}>{campaign?.campaignType?.label}</div>
        </div>
      </div>
      <Divider /> 
      {campaign?.campaignType?.value === CAMPAIGN_TYPES.MAIL && 
        <div className={classes.messagingContainer}>
          <div className={classes.messagingItem}>
            <div className={classes.total}>{Strings.INPUT_LABELS.EMAIL_SUBJECT}</div>
          </div>
          <div className={classes.messagingItem}>
            <div className={classes.total}>{campaign?.emailSubject}</div>
          </div>
        </div>
      }
      <Divider />
      <div className={classes.messagingContainer}>
        {campaign?.campaignType?.value === CAMPAIGN_TYPES.MAIL && 
          <div className={classes.messagingItem}>
            <div className={classes.total}>{Strings.INPUT_LABELS.EMAIL_BODY}</div>
          </div>
        }
        <div className={classes.messagingItem}>
          <div className={classes.total}>
            <ContentEditable 
              className={classes.messageBody}
              id={INPUTS_PROPS.MESSAGE_BODY}
              html={campaign?.messageBody}
              ref={contentEditableRef}
            />
          </div>
        </div>
      </div>
      <Divider />
      {campaign?.campaignType?.value === CAMPAIGN_TYPES.MAIL && campaign.attachment?.length > 0 &&       
        <>
          {!Array.isArray(campaign.attachment) && (
            <div className={classes.messagingContainer}>
              <div className={classes.downloadAttachment}>
                <div className={classes.total}>{Strings.INPUT_LABELS.ATTACHMENT}</div>
                <div className={classes.total}>
                  {fileName}
                  <Button onClick={() => downloadAttachmentByCampaignId(campaign?.campaignId, fileName)} sx={{minWidth: '30px'}}>
                    <img src={Icons.DOWNLOAD}></img>
                  </Button>
                </div>
              </div>
            </div>
          )}
        </>
      }
    </div>
  );
};

export default CampaignDetailsContentCard;
